import styled from 'styled-components';
import { Flex } from 'UI';

export const SReusePartCard = styled(Flex)`
  gap: 10px;
  background-color: ${({ theme }) => theme.color.white};
  border-bottom: solid 1px ${({ theme }) => theme.color.grey85};
  padding-bottom: 16px;
`;

export const SVehicleInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px 15px;
`;

export const SFromLabel = styled.button`
  display: flex;
  gap: 4px;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;
